<template>
  <!-- # 頁籤組件
    1.透過父層 來處理需顯示的頁籤與該頁籤URL

    # 引用組件

    # 備註說明
  -->
  <div class="mfTabHeader tab-header">
    <div class="container-fluid">
      <ul class="nav nav-tabs narrow" role="tablist" id="tab-menu">
        <li
          class="nav-item"
          v-for="item in showTabList"
          :class="{
            active:
              currentTab === item.name || currentTab.indexOf(item.name) === 0,
          }"
          :key="item.name"
        >
          <a href="#;" class="nav-link" @click.prevent="toTabPage(item.URL)">
            {{ item.name }}
          </a>
        </li>
      </ul>
      <div
        v-if="!this.$store.getters.BuTest&& !this.$store.getters.CloseAll"
        @click.prevent="checkFamily(`recommand`)"
        class="btn btn-default btn-lg oldVersionBtn"
        style="
          height: 36px;
          padding: 8px 19px;
          margin: 0px;
          position: absolute;
          right: 20px;
          top: 20px;
        "
      >
        回舊建議書
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    TabList: Array,
    currentTab: {
      type: String,
      default: "",
    },
  },
  name: "TabHeader",
  computed: {
    UserChannelType() {
      return this.$store.getters.UserChannelType;
    },
    showTabList() {
      return this.TabList.filter((item) => {
        if (
          this.$store.getters.IsDirectMarketingUser &&
          !item.directMarketingUser
        ) {
          return false;
        }
        return (
          item.authority.indexOf(this.UserChannelType) > -1 && !item.hidden
        );
      });
    },
  },
  methods: {
    toTabPage(url) {
      this.$router.push(url).catch(() => {});
      // < ---- 清掉store 裡未勾選商品---- >
      this.$store.commit("update_unChecked_mc_idx", {
        data: [],
      });
    },
    checkFamily(url) {
      this.$mfNotice(
        this.$store.getters.CloseOldinv == "1"
          ? "請注意！舊建議書系統已關閉！"
          : "請注意！舊建議書系統「投資型商品」即將於<br /><span style='color:red'>113/2/1</span>關閉，新舊系統彼此獨立，資料不會同步！",
        () => {
          setTimeout(() => {
            // 此處照搬保健的邏輯
            const checkRegex = /\/detail\//;
            const checkInsuranceRegex = /\/insurance-check/;
            const checkRecommandRegex = /\/recommand/;
            localStorage.fromMv = "Y";
            if (this.$store.getters.IsBankUser) {
              //銀保專區另開分頁
              let custFrameSrc =
                "https://w3.cathaylife.com.tw/crms/ProInput/servlet/servlets.goCpa?aggroup=T_UWCCB&source=&HolderID=";
              if (window.location.href.indexOf("//tmycrm") !== -1) {
                custFrameSrc =
                  "https://tw3.cathaylife.com.tw/crms/ProInput/servlet/servlets.goCpa?aggroup=T_UWCCB&source=&HolderID=";
              } else if (window.location.href.indexOf("//smycrm") !== -1) {
                custFrameSrc =
                  "https://sw3.cathaylife.com.tw/crms/ProInput/servlet/servlets.goCpa?aggroup=T_UWCCB&source=&HolderID=";
              }
              custFrameSrc =
                custFrameSrc + "&agid=" + this.$store.state.userInfo.id;
              window.open(custFrameSrc, "_blank");
            } else if (checkRegex.test(window.location.href)) {
              let store = this.$store.state.custInfo;
              if (
                (store.ID == "" || store.ID == undefined) &&
                (store.serNo == "" || store.serNo == undefined)
              ) {
                this.$router.push({ path: `/${url}` });
              } else {
                this.nextTargetUrl = url;
                this.panelOpen("RecommandModalOpen");
              }
            } else if (
              checkInsuranceRegex.test(window.location.href) &&
              url === `recommand`
            ) {
              this.$router.push({ name: url, params: { checkCust: true } });
            } else {
              this.$router.push({ path: `/${url}` });
            }
          }, 200);
        },
        false,
        null,
        "確定",
        this.$store.getters.CloseOldinv == "1"
          ? this.$store.getters.IsBankUser
            ? "舊版建議書已停止使用，傳統型商品和投資型商品皆不再更新商品設定、也無法新增、修改、列印、匯入行動投保、匯入保單健檢等操作，請於「商品建議書」操作建議書。"
            : "舊版建議書已停止使用，傳統型商品和投資型商品皆不再更新商品設定、也無法新增、修改、列印、匯入行動投保、匯入保單健檢等操作，請於「(新)建議書」操作建議書。"
          : "「投資型商品」下架後，暫時仍可至舊系統查詢歷史資料，但舊系統不會再更新商品設定、也無法修改和列印，請同仁及早轉換使用新版建議書系統！"
      );
    },
  },
};
</script>

<style lang="scss">
.mfTabHeader {
  .nav-tabs .nav-item {
    min-width: 124px;
    &.active {
      pointer-events: none;
    }
  }
  .nav-link {
    background-color: #fff !important;
  }
}
</style>
